import "core-js/modules/es.date.to-string.js";
var FOOTER_SCREENSHOT = "https://cdn.faire.com/fastly/539f4fa806de4c091cc04e1e580940b5ff9a90747bba3c73ca95677d363df7be.png";
var localizedFooterHeaderDescription = {
  text: "Column header in the footer of Faire's help center website",
  img: FOOTER_SCREENSHOT
};
var localizedFooterLinkDescription = {
  text: "Link text in the footer of Faire's help center website",
  img: FOOTER_SCREENSHOT
};
export var footerIntro = function footerIntro(strictLocalize) {
  return strictLocalize({
    id: "08toOK",
    defaultMessage: [{
      "type": 0,
      "value": "The online wholesale marketplace connecting independent retailers and brands around the world."
    }]
  });
};
export var faireLinks = function faireLinks(strictLocalize) {
  return [{
    title: strictLocalize({
      id: "9YazHG",
      defaultMessage: [{
        "type": 0,
        "value": "Company"
      }]
    }),
    links: [{
      text: strictLocalize({
        id: "ZjDH42",
        defaultMessage: [{
          "type": 0,
          "value": "About us"
        }]
      }),
      path: "/about"
    }, {
      text: strictLocalize({
        id: "8n7nzo",
        defaultMessage: [{
          "type": 0,
          "value": "Newsroom"
        }]
      }),
      path: "https://news.faire.com/",
      target: "_blank"
    }, {
      text: strictLocalize({
        id: "yJ1ORH",
        defaultMessage: [{
          "type": 0,
          "value": "Careers"
        }]
      }),
      path: "/careers"
    }, {
      text: strictLocalize({
        id: "Jhs7F+",
        defaultMessage: [{
          "type": 0,
          "value": "Partnerships"
        }]
      }),
      path: "/partnerships"
    }]
  }, {
    title: strictLocalize({
      id: "HqRNN8",
      defaultMessage: [{
        "type": 0,
        "value": "Support"
      }]
    }),
    links: [{
      text: strictLocalize({
        id: "HtSDyc",
        defaultMessage: [{
          "type": 0,
          "value": "Help Centre"
        }]
      }),
      path: "/support"
    }, {
      text: strictLocalize({
        id: "PVie/y",
        defaultMessage: [{
          "type": 0,
          "value": "Open with Faire"
        }]
      }),
      path: "/open-with-faire"
    }, {
      text: strictLocalize({
        id: "FomR4q",
        defaultMessage: [{
          "type": 0,
          "value": "Faire Markets"
        }]
      }),
      path: "/markets"
    }, {
      text: strictLocalize({
        id: "gqmtmy",
        defaultMessage: "Apply to Sell"
      }),
      path: "/brands"
    }]
  }, {
    title: strictLocalize({
      id: "+vVZ/G",
      defaultMessage: "Connect"
    }),
    links: [{
      text: "Blog",
      path: "/blog/",
      target: "_blank"
    }, {
      text: "Instagram",
      path: "https://www.instagram.com/faire_wholesale/",
      target: "_blank"
    }, {
      text: "Facebook",
      path: "https://www.facebook.com/fairewholesale/",
      target: "_blank"
    }, {
      text: "Twitter",
      path: "https://twitter.com/faire_wholesale",
      target: "_blank"
    }]
  }];
};
export var policyLinks = function policyLinks(strictLocalize) {
  return [{
    text: "\xA9".concat(new Date().getFullYear(), " Faire Wholesale, Inc."),
    path: "/"
  }, {
    text: strictLocalize({
      id: "32rBNK",
      defaultMessage: [{
        "type": 0,
        "value": "Terms of Service"
      }]
    }),
    path: "/tos"
  }, {
    text: strictLocalize({
      id: "vx0nkZ",
      defaultMessage: [{
        "type": 0,
        "value": "Privacy Policy"
      }]
    }),
    path: "/privacy"
  }, {
    text: strictLocalize({
      id: "cA0kQY",
      defaultMessage: [{
        "type": 0,
        "value": "Cookie policy"
      }]
    }),
    path: "/privacy/cookies"
  }, {
    text: strictLocalize({
      id: "Sqwz5A",
      defaultMessage: [{
        "type": 0,
        "value": "IP Policy"
      }]
    }),
    path: "/copyright"
  }];
};